import React, { useState, useEffect, useRef } from 'react';
import { Box, TextField, Button, Typography, Avatar, Paper } from '@mui/material';
import { useSelector } from 'react-redux';
import { sendPoolChatMessage, getPoolChatMessages } from '../../services/firebase/database';

function PoolChat() {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const user = useSelector((state) => state.auth.user);
  const messagesEndRef = useRef(null);
  const isInitialMount = useRef(true);

  useEffect(() => {
    const unsubscribe = getPoolChatMessages((fetchedMessages) => {
      setMessages(fetchedMessages);
      if (isInitialMount.current) {
        isInitialMount.current = false;
      } else {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSendMessage = async () => {
    if (message.trim() && user) {
      await sendPoolChatMessage(user.uid, user.displayName, user.photoURL || '', message);
      setMessage('');
    }
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 800, mt: 1, p: 2, backgroundColor: '#b9dced' }}>
      <Box sx={{ display: 'flex', alignItems: 'baseline', mb: 2 }}>
        <Typography variant="h6">Pool Chat</Typography>
        <Typography variant="caption" sx={{ ml: 1, color: '#666' }}>Get to know your neighbor, and don't bite!</Typography>
      </Box>
      <Box sx={{ height: 300, overflowY: 'auto', mb: 2, border: '1px solid #eee', p: 1, backgroundColor: '#f9f9f9' }}>
        {messages.map((msg) => (
          <Box key={msg.id} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Avatar src={msg.userPhoto} alt={msg.userName} sx={{ width: 24, height: 24, mr: 1 }} />
            <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1, fontFamily: 'Arial' }}>{msg.userName}:</Typography>
            <Typography variant="body2" sx={{ fontFamily: 'Arial' }}>{msg.message}</Typography>
          </Box>
        ))}
        <div ref={messagesEndRef} />
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Type your message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleSendMessage();
            }
          }}
          inputProps={{
            style: { fontFamily: 'Arial' }
          }}
        />
        <Button variant="contained" onClick={handleSendMessage} disabled={!user}>
          Send
        </Button>
      </Box>
    </Box>
  );
}

export default PoolChat;
